import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2bc8ccac")

_pushScopeId("data-v-2bc8ccac")
const _hoisted_1 = {
  key: 0,
  class: "form-user"
}
const _hoisted_2 = { class: "buttons-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return ($setup.userForm)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        ($props.creation)
          ? (_openBlock(), _createBlock("dig-input-radio-wrapper", {
              key: 0,
              value: $setup.userForm.role,
              onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.userForm.role = $event.detail)),
              required: ""
            }, [
              _createVNode("dig-input-radio", {
                value: `${$setup.Role.admin}`
              }, _toDisplayString($setup.t(`Role.${$setup.Role.admin}`)), 9, ["value"]),
              _createVNode("dig-input-radio", {
                value: `${$setup.Role.user}`
              }, _toDisplayString($setup.t(`Role.${$setup.Role.user}`)), 9, ["value"])
            ], 40, ["value"]))
          : _createCommentVNode("", true),
        _createVNode("dig-input-text", {
          id: "username",
          value: $setup.userForm.username,
          onInput: _cache[2] || (_cache[2] = ($event: any) => ($setup.userForm.username = $event.target.value)),
          required: ""
        }, _toDisplayString($setup.t('User.username')), 41, ["value"]),
        _createVNode("dig-input-text", {
          id: "email",
          value: $setup.userForm.email,
          onInput: _cache[3] || (_cache[3] = ($event: any) => ($setup.userForm.email = $event.target.value)),
          type: "email",
          required: ""
        }, _toDisplayString($setup.t('User.email')), 41, ["value"]),
        _createVNode("dig-input-text", {
          id: "firstname",
          value: $setup.userForm.firstname,
          onInput: _cache[4] || (_cache[4] = ($event: any) => ($setup.userForm.firstname = $event.target.value))
        }, _toDisplayString($setup.t('User.firstname')), 41, ["value"]),
        _createVNode("dig-input-text", {
          id: "lastname",
          value: $setup.userForm.lastname,
          onInput: _cache[5] || (_cache[5] = ($event: any) => ($setup.userForm.lastname = $event.target.value))
        }, _toDisplayString($setup.t('User.lastname')), 41, ["value"]),
        _createVNode("dig-input-phone", {
          id: "phone",
          value: $setup.userForm.phone,
          onInput: _cache[6] || (_cache[6] = ($event: any) => ($setup.userForm.phone = $event.target.value))
        }, _toDisplayString($setup.t('User.phone')), 41, ["value"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("dig-ui-standard-button", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.cancel())),
            disabled: $props.loading,
            class: "cancel"
          }, _toDisplayString($setup.t('cancel')), 9, ["disabled"]),
          _createVNode("dig-ui-standard-button", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.validate())),
            disabled: $props.loading
          }, _toDisplayString($setup.t('validate')), 9, ["disabled"])
        ])
      ]))
    : _createCommentVNode("", true)
})